import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-new-product-success',
  templateUrl: './new-product-success.component.html',
  styleUrls: ['./new-product-success.component.scss']
})
export class NewProductSuccessComponent  implements OnInit, OnDestroy {

  idadministrativo: string;
  translateParams: { idadministrativo: string; };
  headerHtml: string;

  private subscriptions = new Subscription();

  constructor(
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) private data: {
      idadministrativo: string;
    },
  ) {

  }

  ngOnInit() {
    this.idadministrativo = this.data.idadministrativo;
    this.translateParams = { idadministrativo: this.idadministrativo };
    this.subscriptions.add(this.translateService.get('PRODUCTS_KEY.saveSuccessHeader', this.translateParams)
      .subscribe(headerHtml => this.headerHtml = headerHtml));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
